"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var Observable_1 = require("rxjs/Observable");
var from_1 = require("rxjs/observable/from");
/**
 * Created by Vanush Voskanyan
 *
 * Resolves measure type by its pathHolderId
 */
var MeasureTypeResolverService = /** @class */ (function () {
    function MeasureTypeResolverService(_measurePathService) {
        this._measurePathService = _measurePathService;
    }
    MeasureTypeResolverService.prototype.initializeMeasurePaths = function (dataSetId) {
        this._allMeasurePaths = Observable_1.Observable.fromPromise(this._measurePathService.getAllMeasurePaths(dataSetId));
    };
    MeasureTypeResolverService.prototype.getMeasureType = function (measurePathHolderId) {
        return this._allMeasurePaths.map(function (mapOfPaths) {
            return mapOfPaths.get(measurePathHolderId).measurePathType;
        });
    };
    MeasureTypeResolverService.prototype.getMeasureTypes = function (measurePathHolderIds) {
        return from_1.from(this._allMeasurePaths.map(function (mapOfPaths) {
            var map = new Map();
            measurePathHolderIds.forEach(function (measurePathHolderId) {
                map.set(measurePathHolderId, mapOfPaths.get(measurePathHolderId).measurePathType);
            });
            return map;
        }));
    };
    /**
     * Returns measurePathHolderIds with given types
     *
     * @param {MeasurePathType[]} types
     * @returns {Observable<Array<number>>}
     */
    MeasureTypeResolverService.prototype.getMeasuresByType = function (types) {
        return this._allMeasurePaths.map(function (mapOfMeasurePaths) {
            var arrayOfPairs = Array.from(mapOfMeasurePaths);
            var arrayOfFilteredPathHolderIds = [];
            arrayOfPairs
                .filter(function (pair) {
                return types.some(function (type) { return type === pair[1].measurePathType; });
            })
                .forEach(function (pair) {
                arrayOfFilteredPathHolderIds.push(pair[0]);
            });
            return arrayOfFilteredPathHolderIds;
        });
    };
    MeasureTypeResolverService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_dataset_service_client_js_1.MeasurePathService])
    ], MeasureTypeResolverService);
    return MeasureTypeResolverService;
}());
exports.MeasureTypeResolverService = MeasureTypeResolverService;
//# sourceMappingURL=measure-type-resolver.service.js.map